(function($) {
    $.widget("ca.caCheckboxesTable", {
        options: {
            changeable: true,
            rows: null,
            columns: null,
            table_name: '',
            singleRows: [],
            disabled_row_class : null,
            disabled_rows : [],
            disabled_input_style : null,
            keyAsName: false,
            defaultValue: false,
            disabled_columns: []
        },

        _create : function() {
            this.options.table_name = this.element.attr('id');
            this.setChangeable(this.options.changeable);
        },

        setChangeable: function(changeable, rowClass) {
            this.options.changeable = changeable ? true : false;
            if(changeable) {
                this.element.off('click.checkboxesTable').on('click.checkboxesTable','tbody td', function() {
                    if($(this).parents('tr').hasClass('single')) {
                        $(this).parents('tr').find('td').removeClass('selected');
                        $(this).parents('tr').find('input').val(0);
                    }
                    if( !rowClass || $(this).parents('tr').hasClass( rowClass )) {
                        $(this).toggleClass('selected');
                        var input = $(this).find('input');
                        input.val($(this).hasClass('selected')?1:0);
                    }
                    return false;
                }).removeClass('disabled');
            } else {
                this.element.find('tbody').off('click.checkboxesTable').on('click.checkboxesTable','td', function() {
                    return false;
                }).addClass('disabled');
            }
            if (this.options.disabled_row_class) {
                this.element.find('.'+this.options.disabled_row_class).off('click.checkboxesTable').on('click.checkboxesTable','td', function() {
                        return false;
                    }).addClass('disabled');
            }

            if (this.options.disabled_columns) {
                this.element.find('tbody').off('click.checkboxesTable').on('click.checkboxesTable','td.disabled_column', function() {
                    return false;
                }).addClass('disabled');
            }
        },
        
        setSingleRow: function(rowClass, keepValues) {
            this.element.find('tr.' + rowClass).addClass('single');
            this.element.find('tr.' + rowClass + ' td').removeClass('selected');
            
            if (!keepValues) {
                this.element.find('tr.' + rowClass + ' input').val(0);
            }
            
            this.options.singleRows.push(rowClass);
        },
        
        removeSingleRow: function(rowClass) {
            this.element.find('tr.' + rowClass).removeClass('single');
            this.options.singleRows = this.options.singleRows.filter(function(value){value != rowClass});
        },
        
        generateEmptyTable:function (rows, columns) {
            var self = this;
            var html = '<table id="'+self.options.table_name+'" class = "checkboxes-table"><thead class = "thead"><tr><td></td>';

            $j.each(columns, function(index, column) {
                html += '<td>'+column+'</td>';
            });
            html += '</thead><tbody>';
            rows.map(function (row) {
                var value = self.options.defaultValue ? 1 : 0;
                var selected = self.options.defaultValue ? ' selected' : '';
                var rowClass = row.replace(/[^a-z ]+/i, '').replace(' ', '-').toLowerCase();
                if (self.options.disabled_rows.indexOf(row) != -1) {
                    html += '<tr class="' + self.options.disabled_row_class + ' disabled"><th>' + row + '</th>';
                } else {
                    html += '<tr class="row ' + rowClass + '"><th>' + row + '</th>';
                }
                jQuery.each(columns, function(index, column) {
                    var inputName = self.options.keyAsName ? index : column;
                    if (self.options.disabled_rows.indexOf(row) != -1) {
                        html += '<td><input size=3 maxlength="2" style="' + self.options.disabled_input_style  + '" type= "text" name="' + self.options.table_name + '[' + row + '][' + inputName + ']" value=""></td>';
                    } else {
                        html += '<td class="' + selected + '"><input type= "hidden" name="' + self.options.table_name + '[' + row + '][' + inputName + ']" value="' + value + '"></td>';

                        if (self.options.singleRows.indexOf(rowClass) != -1 && value) {
                            selected = '';
                            value = 0;
                        }
                    }
                });

                html += '</tr>';
            });
            html += '</tbody></table>';
            return html;
        },

        setRows: function(rows) {

            var self = this;
            var old_table = self.element.clone();
            self.element.html(self.generateEmptyTable(rows, self.options.columns));
            self.element.find('tbody tr').each(function(row) {
                var index = self.options.rows.indexOf($(this).find('th').html())
                if(index!=-1) {
                    $(this).html(old_table.find('tbody tr')[index].innerHTML);
                }
            });
            self.options.rows = rows;
        },

        setColumns: function(columns) {
            var self = this;
            var old_table = self.element.clone();
            self.element.html(self.generateEmptyTable(self.options.rows, columns));
            self.setChangeable(self.options.changeable);
            for(var i = 0; i < self.options.singleRows.length; i++) {
                self.element.find('tr.' + self.options.singleRows[i]).addClass('single');
            }           
            var row_number = 0;
            self.element.find('tbody tr').each(function(row) {
                var t_row = this;
                var column_number = 0;
                jQuery.each(columns, function(index, column) {
                    if (self.options.columns instanceof Array) {
                        var prevIndex = self.options.columns.indexOf(column);
                    } else {
                        var prevIndex = -1;
                        var k = 0;
                        for (i in self.options.columns) {
                            if (i == index) {
                                prevIndex = k;
                                break;
                            }
                            k ++;
                        }
                    }
                    if(prevIndex!=-1) {
                        var old_cell = $(t_row).find('td')[column_number];
                        var new_cell = $($(old_table.find('tbody tr')[row_number]).find('td')[prevIndex]).clone();
                        $(old_cell).replaceWith(new_cell);
                    }
                    column_number++;
                });
                row_number++;
            });
            self.options.columns = columns;
        }
    });
})(jQuery);
